import ReactOnRails from 'react-on-rails';
import { reportWebVitals } from 'src/helpers/reportWebVitals';
import { reportGoogleTranslate } from 'src/utils/reportGoogleTranslate/reportGoogleTranslate';
import ModernDesktopHomeApp from '../routes/ModernDesktopHome';

import '../styles/pages/modern_desktop_home_page.scss';

ReactOnRails.register({ ModernDesktopHomeApp });

reportWebVitals();

reportGoogleTranslate();
